import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import {
    Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { ShieldOff, RefreshCw } from "lucide-react";

export default function AdminGdpr() {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        api.get("/admin/gdpr/deletions")
            .then(({ data }) => { setItems(data.items || []); setTotal(data.total || 0); })
            .catch(() => toast.error("Errore caricamento registro"))
            .finally(() => setLoading(false));
    };
    useEffect(() => { load(); }, []);

    return (
        <div data-testid="admin-gdpr-page">
            <div className="flex items-baseline justify-between mb-6 gap-4">
                <div>
                    <h1 className="font-serif text-3xl mb-2">Registro cancellazioni GDPR</h1>
                    <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-xl">
                        Traccia anonima delle cancellazioni account (self o admin). Conserva solo
                        un hash SHA-256 non reversibile dell'email per fini di accountability.
                    </p>
                </div>
                <button onClick={load} disabled={loading} className="co-btn-ghost text-xs" data-testid="admin-gdpr-refresh">
                    <RefreshCw className="w-3.5 h-3.5" /> Aggiorna
                </button>
            </div>

            <div className="mb-4 text-sm text-[hsl(var(--muted-foreground))]">
                Totale record: <b className="text-[hsl(var(--foreground))]" data-testid="admin-gdpr-total">{total}</b>
            </div>

            <div className="bg-white border border-[hsl(var(--border))] rounded-sm overflow-x-auto">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Data</TableHead>
                            <TableHead>Ruolo</TableHead>
                            <TableHead>Cancellato da</TableHead>
                            <TableHead>Email (hash SHA-256)</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {loading && (
                            <TableRow><TableCell colSpan={4} className="text-center py-8 text-[hsl(var(--muted-foreground))]">Caricamento…</TableCell></TableRow>
                        )}
                        {!loading && items.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={4} className="text-center py-12">
                                    <ShieldOff className="w-8 h-8 mx-auto text-[hsl(var(--muted-foreground))] mb-2" strokeWidth={1.2} />
                                    <div className="text-sm text-[hsl(var(--muted-foreground))]" data-testid="admin-gdpr-empty">
                                        Nessuna cancellazione registrata.
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                        {items.map((e) => (
                            <TableRow key={e.id} data-testid={`admin-gdpr-row-${e.id}`}>
                                <TableCell className="text-xs">{typeof e.deleted_at === "string" ? e.deleted_at.replace("T", " ").slice(0, 19) : "—"}</TableCell>
                                <TableCell><span className="co-badge-neutral text-[10px]">{e.role_at_deletion}</span></TableCell>
                                <TableCell className="text-xs">{e.deleted_by === "self" ? "Utente stesso" : `Admin (${(e.deleted_by || "").slice(0, 8)}…)`}</TableCell>
                                <TableCell className="text-xs font-mono truncate max-w-[280px]" title={e.email_sha256}>
                                    {e.email_sha256}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
